import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, Navigate } from 'react-router-dom';

export default function ProtectedTeacherRoute() {
    const { isAuthenticated, user } = useSelector(state => state.root);
    if (!isAuthenticated) return <Navigate to="/" replace />;
    if (user.type === 'teacher') return <Outlet />;
    return <Navigate to={user.type === 'student' ? '/student' : '/admin'} replace />;
}
